import {paging} from  './utilities';
export default {
    data: () => ({
        pageSize: 10,
        pagedData: [],
        currentPage: 1
    }),
    methods:{
        pageData(data = [], page){
            this.pagedData = paging(data, page, this.pageSize);
            this.currentPage = page;
            return this.pagedData;
        },

        pageChange(page, data){
            this.pagedData = this.pageData(data, page);
        }

    }
}
